import { CircularProgress } from '@mui/material';

import Button from '@/components/Buttons/Button';
import useChartImageExport from '@/components/Chart/hooks/useChartImageExport';
import { ExportDrawerCancelButton } from '@/features/DataHub/components/ExportDrawer/ExportDrawerCancelButton';
import {
  useExportPreview,
  useExportRequest,
  useExportSettings
} from '@/features/DataHub/modules/Export/context/exportContexts';
import { getDateRangeValidation } from '@/features/DataHub/modules/Export/utils';

import type { ExportingMimeTypeValue } from 'highcharts';

const ImageFooterButtons = () => {
  const { previewHasNoData, previewLoading } = useExportPreview();
  const { capturePosthogEvent } = useExportRequest();
  const { onExport } = useChartImageExport();
  const { exportSettings, updateExportSetting } = useExportSettings();
  const dateRangeValidation = getDateRangeValidation({
    dateRangeType: exportSettings.dateRangeType,
    from: exportSettings.from,
    to: exportSettings.to,
    periodNumber: exportSettings.periodNumber
  });
  const hasDateSettingsError =
    dateRangeValidation.periodNumberError ||
    dateRangeValidation.fromError ||
    dateRangeValidation.toError;

  const handleButtonClick = () => {
    if (hasDateSettingsError) return;

    if (exportSettings.exportSubType) {
      capturePosthogEvent();
      onExport(exportSettings.exportSubType as ExportingMimeTypeValue);
      updateExportSetting('exportSubType', undefined);
    }
  };
  return (
    <>
      <ExportDrawerCancelButton />
      <Button
        disabled={previewLoading || previewHasNoData || hasDateSettingsError}
        startIcon={
          previewLoading ? (
            <CircularProgress
              color='inherit'
              size={16}
            />
          ) : undefined
        }
        variant='contained'
        onClick={handleButtonClick}
      >
        Download
      </Button>
    </>
  );
};

export default ImageFooterButtons;
